module.exports = __webpack_public_path__ + "static/media/picture-(176).ca462420.JPG";